import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';

import { GroupService } from '../../services/group.service';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { Globals } from '../../globals';

@Component({
    selector: 'app-read-group',
    templateUrl: './read-group.component.html',
    styleUrls: ['./read-group.component.css', '../../app.component.css']
})

export class ReadGroupComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    groups: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Nombre', name: 'name' },
        { title: 'Descripción', name: 'description' },
        { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'info', title: '', styleIcon: 'group', action: 'onInfo',
              styleClass: 'btn-floating btn waves-effect light-blue lighten-1' },
            { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
              styleClass: 'btn-floating btn waves-effect light-green darken-1' },
            { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
              styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
            onInfo: this.onInfo.bind(this),
            onEdit: this.onEdit.bind(this),
            onDelete: this.onDelete.bind(this)
        }
    };

    infoModalActions = new EventEmitter<string|MaterializeAction>();
    infoModalParams = [ {
        dismissible: false,
        complete: function() {
            // console.log('Modal : Close');
        }
    } ];

    users: any[] = [];
    usersInfo = [];
    groupSelected = '';

    guSubs: any;
    ggSubs: any;

    permissions = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: GroupService,
        private userService: UserService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        this.loadUsers();
        this.loadGroups();
    }

    ngOnInit() {

    }

    loadUsers() {
        this.guSubs = this.userService.getUsers().subscribe(tempUsers => {
            this.guSubs.unsubscribe();

            this.users = [];

            for (const idx in tempUsers) {
                this.users.push(tempUsers[idx]);
            }
        });
    }

    loadGroups() {
        this.ggSubs = this.service.getGroups().subscribe(tempGroups => {
            //add new permission
            /* tempGroups.map(group => {
                this.service.postGroupPermission(group.id$, Globals.MACHINE_COLLECTION, Globals.newPermission('Catálogos / Máquinas'));
            }); */
            this.ggSubs.unsubscribe();

            this.groups = [];

            for (const idx in tempGroups) {
                this.groups.push(tempGroups[idx]);
            }

            this.data = this.groups;
            this.length = this.data.length;
            this.onChangeTable(this.config);

            //Change all permissions
            /* tempGroups.map(group => {
                if(group.id$ == 'iHjYuiQMGnkoO50ucB6h') return;
                let pSub = this.service.getPermissionCollection(group.id$).subscribe(permissions => {
                    pSub.unsubscribe();
                    permissions.map(permission => {
                        this.service.putGroupPermission(group.id$, permission.id, {
                            createAction: false, readAction: false, updateAction: false, deleteAction: false
                        });
                    })
                })
            }); */
        });
    }

    onCellClick(data: any): any {
        this.router.navigate(['/vw_group/' + data.row.id$]);
    }

    onCreate(){
      if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
      this.router.navigate(['/add_group']);
    }

    onEdit(data: any) {
		if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);

        this.router.navigate(['/edt_group/', data.row.id$]);
    }

    onDelete(data: any) {
		if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
        this.service.delGroup(data.row.id$).then(res => {
            this.loadGroups();
        });
    }

    onInfo(data: any) {
        for (const idx in this.users) {
            if (this.users[idx].groups.indexOf(data.row.id$) > -1) {
                this.usersInfo.push(this.users[idx]);
            }
        }

        this.groupSelected = data.row.name;

        this.openInfoModal();
    }

    openInfoModal() {
        this.infoModalActions.emit({ action: 'modal', params: ['open'] });
    }

    closeInfoModal() {
        this.usersInfo = [];
        this.groupSelected = '';

        this.infoModalActions.emit({ action: 'modal', params: ['close'] });
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
